import * as actionTypes from './actionTypes';
import constants from "../../utils/constants";

const log = require("loglevel").getLogger("marketingReducer");
log.setLevel("debug");

const initialState = JSON.stringify({
	marketing: null,
	lastUpdated: null
});

function marketingReducer(state = JSON.parse(initialState), action) {
	switch (action.type) {
		case constants.GLOBAL_ACTION_INIT_STATE: {
			log.debug("reset program state");
			return initialState;
		}
		case actionTypes.MARKETING_LOADED: {
			const loadedMarketing = action.data;
			let {marketing} = state;
			const index = (marketing || []).findIndex(m => m.Id === loadedMarketing.Id);

			if(index > -1) {
				marketing[index] = loadedMarketing;
			}
			else {
				marketing = [loadedMarketing];
			}

			return {
				...state,
				marketing
			};
		}
		case actionTypes.MARKETINGS_LOADED: {
			return {
				...state,
				marketing: action.data,
				lastUpdated: action.lastUpdated
			};
		}
		default:
			return state;
	}
}

export default marketingReducer;
